import React, { Component,PropTypes } from 'react';
import { Link,browserHistory } from "react-router";
import {ellaUrl} from '../../../path.config'
export default class SubsystemsyncAdd extends Component {
	constructor(props) {
		super(props);
		this.btnSubmit = this.btnSubmit.bind(this);
		this.state = {
			nodeVos:[],
			url:ellaUrl
		};
	}

    overlaycomplete(e){
        var overlays = this.state.overlays;
        var result="画图开始：  ";
        overlays.push(e.overlay);
        this.setState({
            overlays : overlays
        })
        if (e.drawingMode == BMAP_DRAWING_MARKER) {  //点
            result += "坐标：" + e.overlay.getPosition().lng + "," + e.overlay.getPosition().lat;
            console.log(result)
        }
        if (e.drawingMode == BMAP_DRAWING_CIRCLE) {
            result += " 半径：" + e.overlay.getRadius();
            result += " 中心点：" + e.overlay.getCenter().lng + "," + e.overlay.getCenter().lat;
            console.log(result)
        }

        if (e.drawingMode == BMAP_DRAWING_POLYLINE || e.drawingMode == BMAP_DRAWING_POLYGON || e.drawingMode == BMAP_DRAWING_RECTANGLE) {
            //alert(e.overlay.getPath().length);
            var mapData = [];
            for(var i = 0; i < e.overlay.getPath().length; i++){//循环连线个数
                var object = new Object();
                object.lnglatX = e.overlay.getPath()[i].lng;
                object.lnglatY = e.overlay.getPath()[i].lat;
                result += "坐标："+object.lnglatX + "," + object.lnglatY;
                mapData.push(object.lnglatX + "," + object.lnglatY)
            }
            console.log(result)
            console.log(mapData.join("|"))
        }
        document.getElementById('panel').innerHTML += result; //将绘制的覆盖物信息输出到结果面板

    }
    componentDidMount(){
        var map = new BMap.Map('map');
        var poi = new BMap.Point(116.307852,40.057031);
        map.centerAndZoom('余杭区', 16);
        map.enableScrollWheelZoom();

        var styleOptions = {
            strokeColor:"red",    //边线颜色
            fillColor:"red",      //填充颜色，当参数为空时，圆形将没有填充效果
            strokeWeight: 3,       //边线的宽度，以像素为单位
            strokeOpacity: 0.8,	   //边线透明度 0-1
            fillOpacity: 0.6,      //填充的透明度 0-1
            strokeStyle: 'solid' //边线的样式，solid或者dashed
        }
        //实例化鼠标绘制工具
        var drawingManager = new BMapLib.DrawingManager(map, {
            isOpen: false, //是否开启绘制模式
            enableDrawingTool: true, //是否显示工具栏
            drawingToolOptions: {
                anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
                offset: new BMap.Size(5, 5), //偏离值
            },
            circleOptions: styleOptions, //圆的样式
            polylineOptions: styleOptions, //线的样式
            polygonOptions: styleOptions, //多边形的样式
            rectangleOptions: styleOptions //矩形的样式
        });
        drawingManager.addEventListener('overlaycomplete', this.overlaycomplete.bind(this));
        this.setState({
            map:map
        })
    }

    clearAll(){
        const overlays = this.state.overlays;
        const map = this.state.map
        for(var i = 0; i < overlays.length; i++){
            map.removeOverlay(overlays[i]);
        }
        this.setState({
            overlays : [],
        })
    }
    overlaysLength(){
        alert(this.state.overlays.length);
    }

	btnSubmit(){
		var name = $("#name").val();
		var url = $("#url").val();
		var remark = $("#remark").val();
		
		var data = {
			name:name,
			url:url,
			remark:remark
		};
		console.log(JSON.stringify(data));
		$.ajax({
			type:"POST",
			url:this.state.url+"/subsystemsync/doAddOrUpdate",
			contentType: "application/json;charset=UTF-8",
			data:JSON.stringify(data),
			success:function(data){
				if (data.code == 8001) {
					$("#success_msg").text(data.msg);
					$("#success_tip").removeClass("hidden");
					setTimeout(function() {
						$("#success_tip").addClass("hidden");
					}, 2000);
				} else {
					$("#error_msg").text(data.msg);
					$("#error_tip").removeClass("hidden");
					setTimeout(function() {
						$("#error_tip").addClass("hidden");
					}, 2000);
				}
			}.bind(this),
			error:function(){
				console.log("submit error");
			}.bind(this),
		});
	}
	render() {
		return (
			<div >
				<section className="content-header " >
			        <h1> 子系统同步信息管理 <small>添加子系统同步信息</small> </h1>
			    </section>
			    <section className="content" >
		        <div className="box box-primary color-palette-box">
		            <div className="box-header with-border">
		               	<i className="fa fa-plus-circle"></i>
		                <h3 className="box-title">添加子系统同步信息</h3>
		            </div>
		            <div className="box-body">
		                <div id={"error_tip"} className="hidden alert-tip">
		                    <div className="alert alert-danger">
		                      	<strong>Whoops!</strong>
		                        <button type="button" className="close" data-dismiss='alert'>×</button>
		                        <span id={"error_msg"}>&nbsp;提交失败.</span>
		                    </div>
		                </div> 
		             	<div id={"success_tip"} className="hidden alert-tip">
		                    <div className="alert alert-success">
		                        <button type="button" className="close" data-dismiss='alert'>×</button>
		                        <strong>Success.</strong><span id={"success_msg"}>提交成功</span>
		                    </div>
		             	</div>
		             	<form>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">系统名称</label>
					            <div className="col-xs-4">
						            <input type="text" className="form-control" placeholder="系统名称" id="name"/>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">访问路径</label>
					            <div className="col-xs-4">
						            <input type="text" className="form-control" placeholder="访问路径" id="url"/>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-1">备注</label>
					            <div className="col-xs-4">
						            <textarea cols="49" rows="3" id="remark" style={{padding:"6px 12px"}}></textarea>
						        </div>
			             	</div>
							<div className="row form-group">
								<label  className="multi-label control-label col-xs-1">区域</label>
								<div className="col-xs-4">
									<div>
										<div id="allmap" style={{"overflow":"hidden","zoom":"1","position":"relative"}}>
											<div id="map" style={{"height":"100%","-webkit-transition": "all 0.5s ease-in-out","transition":"all 0.5s ease-in-out"}}></div>
										</div>
										<div id="result">
											<input type="button" value="获取绘制的覆盖物个数" onClick = {this.overlaysLength.bind(this)}/>
											<input type="button" value="清除所有覆盖物" onClick={this.clearAll.bind(this)}/>
										</div>
										<div id="panel" style={{"position":"absolute"}}></div>
									</div>
								</div>
							</div>
			             	<div className="row form-group">
			             		<div className="col-xs-1"></div>
						        <div className="col-xs-1 text-center">
						            <button className="btn btn-success" onClick={this.btnSubmit}>提交</button>
						        </div>
					            <div className="col-xs-1 text-center">
					                <Link  to = "/ella/user/subsystemsync/subsystemsyncIndex" className="btn btn-danger btn-md">
		                        		返回
		                    		</Link>
					            </div>
					        </div> 
		             	</form>
		        	</div>
				</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/subsystemsync/subsystemsyncAdd.js